import {
  MY_QUEUE,
  QC,
  PENDING,
  IN_PROGRESS,
  RECENTLY_READ,
  ARCHIVE,
  WORKLIST_VIEW,
  STUDIES_DIALOG,
  PATIENT_JACKET_PRIORS,
  GLOBAL_SEARCH,
  PUBLIC_WORKLIST,
  PRIVATE_WORKLIST,
} from 'config/constants';

export const WorklistSurface = Object.freeze({
  MY_QUEUE: MY_QUEUE,
  QC: QC,
  PENDING: PENDING,
  IN_PROGRESS: IN_PROGRESS,
  RECENTLY_READ: RECENTLY_READ,
  ARCHIVE: ARCHIVE,
  WORKLIST_VIEW: WORKLIST_VIEW,
  STUDIES_DIALOG: STUDIES_DIALOG,
  PATIENT_JACKET_PRIORS: PATIENT_JACKET_PRIORS,
  PLACEHOLDER: 'PLACEHOLDER',
  GLOBAL_SEARCH: GLOBAL_SEARCH,
  CUSTOM_WORKLIST: 'CUSTOM_WORKLIST',
});

export type WorklistSurfaceType =
  | 'MY_QUEUE'
  | 'QC'
  | 'PENDING'
  | 'IN_PROGRESS'
  | 'RECENTLY_READ'
  | 'ARCHIVE'
  | 'STUDIES_DIALOG'
  | 'WORKLIST_VIEW'
  | 'PATIENT_JACKET_PRIORS'
  | 'PLACEHOLDER'
  | 'GLOBAL_SEARCH'
  | 'CUSTOM_WORKLIST';

export type WorklistStatusWithLock =
  | 'Locked'
  | 'ADNDM Locked'
  | 'Queued'
  | 'ADNDM Queued'
  | 'Completed'
  | 'Verified'
  | 'Countdown'
  | 'ADNDM Countdown'
  | 'Externally Read'
  | 'QC';

export const CAN_CLAIM_LOCKED_CASE_SURFACES: Array<WorklistSurfaceType> = [
  WorklistSurface.IN_PROGRESS,
  WorklistSurface.WORKLIST_VIEW,
  WorklistSurface.CUSTOM_WORKLIST,
];

export const WorklistSelection = Object.freeze({
  PRIVATE: PRIVATE_WORKLIST,
  PUBLIC: PUBLIC_WORKLIST,
});

export type WorklistSelectionType = (typeof WorklistSelection)[keyof typeof WorklistSelection];
